import { normalizeHref as sharedNormalizeHref } from 'shared'

/**
 * @deprecated Use normalizeHref from 'shared' package instead
 */
export const normalizeHref = (href: string) => {
  return sharedNormalizeHref(href)
}
